"use client"

import { Button, Text } from "@/elements"
import React, { FC } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import type { NovaSession } from "@/types"
import Link from "next/link"

const AuthenticatedClientJobDetailsFooterFragment = graphql(`
  fragment AuthenticatedClientJobDetailsFooter on JobPosting {
    __typename
    id
    payString
    employmentTypeDisplay
    owner {
      id
    }
  }
`)

interface Props {
  jobPosting: FragmentType<typeof AuthenticatedClientJobDetailsFooterFragment> | undefined | null
  serverSession: NovaSession
}

export const AuthenticatedClientJobDetailsFooter: FC<Props> = props => {
  const { serverSession } = props
  const jobPost = useFragment(AuthenticatedClientJobDetailsFooterFragment, props.jobPosting)

  const isMyJobPosting =
    (jobPost?.owner.id === serverSession.user.client.id && serverSession.account === "client") ||
    (jobPost?.owner.id === serverSession.user.creative.id && serverSession.account === "creative")

  return (
    <div className="fixed bottom-0 left-0 flex w-full justify-center sm:bottom-9 md:left-[96px] md:w-[calc(100%-96px)] lg:left-[224px] lg:w-[calc(100%-224px)]">
      <div
        style={{
          boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.20)",
        }}
        className="flex w-full flex-row items-center justify-between border border-bg-3 bg-bg-1 px-[34px] py-[25px] sm:mx-6 sm:max-w-[768px] sm:rounded-xl">
        <div className="flex flex-col gap-y-1">
          <Text variant="h5">{jobPost?.payString}</Text>
          <Text variant="label" className="text-fg-2">
            <span className="hidden sm:inline">Job type: </span>
            {jobPost?.employmentTypeDisplay}
          </Text>
        </div>
        {isMyJobPosting ? (
          <Link href={`/hire/${jobPost?.id}?tab=applications`}>
            <Button size="large" variant="tertiary">
              Manage job
            </Button>
          </Link>
        ) : null}
      </div>
    </div>
  )
}
